module.exports = __webpack_public_path__ + "static/img/coast.e913c6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coast.jpg
// module id = TBx/
// module chunks = 1